import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

/****
 * A pretty toggle for boolean values.
 *
 * Appears in the form as a hidden field with a value of '0' or '1'.
 * 
 * Props:
 *
 * defaultValue: boolean
 * on: mixed, will be treated as truthy/falsy; "0" and "false" will be interpreted as false
 * reverse: boolean, if the semantic of the propery is "opposite" use this to avoid NOT back-bending.
 */
export default class Toggle extends Component {
  static propTypes = {
    on: PropTypes.any,
    reverse: PropTypes.bool,
    defaultOn: PropTypes.bool,
    onChange: PropTypes.func,
    name: PropTypes.string,
    disabled: PropTypes.bool
  }

  static defaultProps = {
    defaultOn: false,
    reverse: false,
    onChange: x => x
  }

  constructor(props) {
    super(props)

    // if props.on is given, use it
    var booleanizedPropsOn
    if (typeof(props.on) === 'undefined') {
      booleanizedPropsOn = props.defaultOn
    } else {
      // treat "0", "false" as false
      if (props.on === '0' || props.on === 'false') {
        booleanizedPropsOn = false
      } else {
        booleanizedPropsOn = !!props.on
      }
    }

    this.state = {
      on: (props.reverse ? !booleanizedPropsOn : booleanizedPropsOn),
      reverse: props.reverse
    }
    //console.log(`[${props.name}] Toggle initial state: props.on=${props.on}, booleanized=${booleanizedPropsOn}, reverse=${props.reverse}:${this.state.reverse}, final internal this.state.on=${this.state.on}`)
  }

  // Internal function to set the "on" state; should be used internally everywhere but constructor to do this
  // ensures the change is propagates to external subscribers
  _setOnState = newOn => {
    if (!this.props.disabled) {
      this.setState({ on: newOn }, () => {
        //console.log(`[${this.props.name}] Sending onChange ${this._getExternalOnState()}`)
        this.props.onChange(this._getExternalOnState())
      })
    }
  }

  // Internal helper function to set "on" state which internally handles `reverse` feature
  // Should be used anytime the input value is coming from external to the component
  _setExternalOnState = newState => {
    let newOn = newState
    if (this.state.reverse) {
      newOn = !newOn
    }
    //console.log(`[${this.props.name}] Toggle._setExternalOnState(${newState}): current value: state.on: ${this.state.on}, reverse=${this.state.reverse}, newOn=${newOn}`)
    this._setOnState(newOn)
  }

  // Internal helper function to get "on" state which internally handles `reverse` feature
  // Should be used any time we want the value of "on" that should be shared external to this component
  _getExternalOnState = () => {
    if (this.state.reverse) {
      return !this.state.on
    }
    return this.state.on
  }

  _toggleEventHandler = event => {
    event.preventDefault()
    //console.log(`[${this.props.name}] Toggle._toggleEventHandler(): current value: state.on: ${this.state.on}, reverse=${this.state.reverse}, newOn=${!this.state.on}`)
    this._setOnState(!this.state.on)
  }

  // NOTE: this existed prior to the refactor. I haven't seen it be called yet so I am not sure if it works properly
  // as I have no idea where in the app/code it gets exercised.
  componentWillReceiveProps(nextProps) {
    //console.log(`[${this.props.name}] componentWillReceiveProps`)
    if (nextProps.on !== this.props.on && nextProps.on !== undefined) {
      this._setExternalOnState(nextProps.on)
    }
  }

  getLabel() {
    if (this.props.children) {
      let children
      if (typeof this.props.children === 'function') {
        //console.log(`[${this.props.name}] children on=${this._getExternalOnState()}`)
        children = this.props.children(this._getExternalOnState())
      } else {
        children = this.props.children
      }
      return (
        <label onClick={this._toggleEventHandler}>
          {children}
        </label>
      )
    }
  }

  render() {
    const { name, disabled } = this.props
    const on = this.state.on
    const className = classnames('toggle-container', { on, disabled })

    return (
      <div className={className}>
        <div className="toggle" onClick={this._toggleEventHandler}>
          <div className="toggle-track" />
          <div className="toggle-notch" />
          <input type="hidden" name={name} value={this._getExternalOnState() ? '1' : '0'} readOnly />
        </div>
        {this.getLabel()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/settings/Form/toggle.js